export default {
  loginButton: 'Sign In',
  signupButton: 'New user? Sign Up',
  version: 'Version',
} as const;
